type DoctorNameParts = {
  firstName?: string | null;
  middleName?: string | null;
  lastName?: string | null;
};

export const formatDoctorDisplayName = (doctor: DoctorNameParts): string =>
  [doctor.firstName, doctor.lastName].filter(Boolean).join(" ");

export const formatDoctorSignatureName = (doctor: DoctorNameParts): string =>
  [doctor.firstName, doctor.middleName, doctor.lastName]
    .filter(Boolean)
    .join(" ");
